<template>
  <div>
    <SnackbarComponent v-model="snackbar.show" :message="snackbar.message" :color="snackbar.color" />
    <v-dialog v-model="dialog" max-width="500px" persistent>
      <v-card>
        <v-card-title class="text-h6 pa-4">
          Confirm Unpublish Testimonial
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pa-6">
          <div class="text-body-1">
            Are you sure you want to unpublish this Testimonial?
          </div>
          <div v-if="testimonial" class="mt-4">
            <div class="mb-2">
              <strong>User Name:</strong>
              {{ testimonial.testimonial_user_name || "-" }}
            </div>

            <div class="mb-2">
              <strong>Message:</strong>
              <div class="mt-1 pa-2" v-html="testimonial.testimonial_description
                  ? testimonial.testimonial_description.substring(0, 150) +
                  (testimonial.testimonial_description.length > 150 ? '...' : '')
                  : '-'
                " />
            </div>

            <div>
              <strong>Status:</strong>
                {{ testimonial.testimonial_status || "-" }}
            </div>
          </div>
          <div class="text-caption text-medium-emphasis mt-2">
            The testimonial will be hidden from users but can be republished later.
          </div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="pa-4">
          <v-spacer></v-spacer>
          <v-btn color="grey" variant="text" @click="handleClose" :disabled="loading">
            Cancel
          </v-btn>
          <v-btn color="warning" variant="flat" @click="handleUnpublish" :loading="loading">
            Unpublish
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { generateClient } from "aws-amplify/api";
const client = generateClient();
import { edit_testimonial } from "@/graphql/mutations";
import SnackbarComponent from "@/components/Extras/Snackbar.vue";

export default {
  name: "UnpublishTestimonialDialog",
  components: {
    SnackbarComponent,
  },
  props: {
    modelValue: {
      type: Boolean,
      default: false,
    },
    testimonial: {
      type: Object,
      default: null,
    },
  },
  emits: ["update:modelValue", "unpublished"],
  data() {
    return {
      loading: false,
      snackbar: {
        show: false,
        message: "",
        color: "success",
      },
    };
  },
  computed: {
    dialog: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit("update:modelValue", value);
      },
    },
  },
  methods: {
    handleClose() {
      this.dialog = false;
    },
    async handleUnpublish() {
      if (!this.testimonial?.testimonial_id) {
        return;
      }

      this.loading = true;
      try {
        const input = {
          testimonial_id: this.testimonial.testimonial_id,
          testimonial_status: "UNPUBLISHED",
        };

        const response = await client.graphql({
          query: edit_testimonial,
          variables: {
            input: input,
          },
        });

        const responseData = JSON.parse(response.data.edit_testimonial);
        // console.log(responseData);

        if (responseData.status === "SUCCESS") {
          this.snackbar = {
            show: true,
            message: responseData.status_message || "testimonial unpublished successfully!",
            color: "success",
          };
          this.dialog = false;
          this.$emit("unpublished");
        } else {
          this.snackbar = {
            show: true,
            message: responseData.status_message || "Failed to unpublish testimonial",
            color: "error",
          };
        }
      } catch (error) {
        console.error("Error unpublishing testimonial:", error);
        this.snackbar = {
          show: true,
          message: (error.errors && error.errors[0]?.message) || error.message || "An error occurred while unpublishing testimonial",
          color: "error",
        };
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped></style>
